import { api } from "../../services/api"

let timeout = 0
const timeoutList = (v, endpoint, field, label, setState, value=false, customLabelFormatter=null) => {
    clearTimeout(timeout)
    timeout = setTimeout(() => { getItemList(v, endpoint, field, label, setState, value, customLabelFormatter) }, 500)
}

const getItemList = async (v, endpoint, field, label, setState, value=false, customLabelFormatter=null) => {
    setState({smallLoading: true})
    const res = await api.post(endpoint, {search: v}, {timeout: 10000})
    const result = {smallLoading: false}
    if (res.status === 200){
        result[field] = res.data.map((e) => {
            // Se há um formatador customizado, usar ele para o label
            let finalLabel = e[label]
            if (customLabelFormatter) {
                finalLabel = customLabelFormatter(e)
            }
            
            return {
                label: finalLabel, 
                id: e.id, 
                ...(value ? {value: e.value} : {}),
                // Incluir campos adicionais para clientes
                ...(e.corporate_name ? {corporate_name: e.corporate_name} : {}),
                data: e
            }
        })
    }
    setState(result)
}

export const timeoutIntegratedList = (v, endpoint, field, label, setState, value=false) => {
    clearTimeout(timeout)
    timeout = setTimeout(() => { getItemIntegratedList(v, endpoint, field, label, setState, value) }, 500)
}

const getItemIntegratedList = async (v, endpoint, field, label, setState, value=false) => {
    setState({smallLoading: true})
    const searchParam = v ? `?${label}=${v}` : ''
    const res = await api.post(endpoint[0], {method: 'GET', path: endpoint[1] + searchParam}, {timeout: 10000})
    const result = {smallLoading: false}
    if (res.status === 200){
        result[field] = (res.data.results || res.data).map((e) => ({label: e[label], id: e.id, ...(value ? {value:e.value} : {}) ,data: e}))
    }
    setState(result)
}

export default timeoutList